module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "index-slider"
  }, [_c('div', {
    staticClass: "bg"
  }, [_c('div', {
    staticClass: "progress-bar",
    style: ({
      width: _vm.percentage + '%'
    })
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e9266872"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/indexSlider.vue
// module id = 932
// module chunks = 1